import { axInst, axInstBasic } from "../Service/Service";

// export const fetchAccountName = async (searchData) => {
//   // console.log(axInst);
//   try {
//     const res = await axInst.post(
//       `${process.env.REACT_APP_API_URL}customerAccountName`,
//       { searchData }
//     );
//     return res.data.result;
//   } catch (error) {
//     console.error(error);
//     throw error;
//   }
// };
export const fetchAccountName = async (searchData) => {
  try {
    const res = await axInst.post(
      `${process.env.REACT_APP_API_URL}customerAccountName`,
      { searchData }
    );

    return res.data?.result?.by_parent_name?.buckets || [];
  } catch (error) {
    console.error(error);
    throw error;
  }
};
export const fetchGoldenAccountName = async (searchData) => {
  try {
    const res = await axInst.post(
      `${process.env.REACT_APP_API_URL}customerGoldenAccountName`,
      { searchData }
    );
    return res.data.result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
export const fetchCustomerGoldenArn = async (searchData) => {
  try {
    const res = await axInst.post(
      `${process.env.REACT_APP_API_URL}customerGoldenArn`,
      { searchData }
    );
    return res.data.result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchArnNumber = async (searchData) => {
  try {
    const res = await axInst.post(
      `${process.env.REACT_APP_API_URL}customerArn`,
      { searchData }
    );
    return res.data.result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
export const customerVehicleRegistrationNumber = async (searchData) => {
  try {
    const res = await axInst.post(
      `${process.env.REACT_APP_API_URL}customerVehicleRegistrationNumber`,
      { searchData }
    );
    return res.data.result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
export const customerKeyAccountLocation = async (searchData) => {
  try {
    const res = await axInst.post(
      `${process.env.REACT_APP_API_URL}customerKeyAccountLocation`,
      { searchData }
    );
    return res.data.result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

// fetch chassis Number API
export const fetchChassisNumber = async (searchData) => {
  try {
    const res = await axInst.post(
      `${process.env.REACT_APP_API_URL}customerFetchChassisNumber`,
      { searchData }
    );
    return res.data.result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
// fetch chassis Number API
export const fetchPhoneNumber = async (searchData) => {
  try {
    const res = await axInst.post(
      `${process.env.REACT_APP_API_URL}customerPhoneNumber`,
      { searchData }
    );
    return res.data.result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

// fetch chassis Number API
export const fetchChildData = async (arn) => {
  try {
    const res = await axInst.post(
      `${process.env.REACT_APP_API_URL}customergetChildArnData`,
      { arn }
    );
    return res.data.result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};


// ../CustSearch/apiSearch.js
export const fetchtotalid = async (payload) => {

  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}getFleetIdDetails`, payload
    );

    // console.log("Fleet ID API result:", payload);

    return res.data.result || []; // return array safely
  } catch (error) {
    console.error("Error fetching fleet ID:", error);
    throw error;
  }
};




export const fetchgoldenacc = async (payload) => {

  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}getGoldenAccDetails`, payload
    );

    // console.log("Fleet ID API result:", payload);

    return res.data.result || []; // return array safely
  } catch (error) {
    console.error("Error fetching fleet ID:", error);
    throw error;
  }
};


export const fetchpsf = async (payload) => {

  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}psf_sales`, payload
    );

    // console.log("Fleet ID API result:", payload);

    return res.data.result || []; // return array safely
  } catch (error) {
    console.error("Error fetching fleet ID:", error);
    throw error;
  }
};


export const fetchpsfservice = async (payload) => {

  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}psf_service`, payload
    );

    // console.log("Fleet ID API result:", payload);

    return res.data.result || []; // return array safely
  } catch (error) {
    console.error("Error fetching fleet ID:", error);
    throw error;
  }
};


export const fetchpsfbarchart = async (payload) => {

  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}psfSalesMonthChart`, payload
    );

    // console.log("Fleet ID API result:", payload);

    return res.data.result || []; // return array safely
  } catch (error) {
    console.error("Error fetching fleet ID:", error);
    throw error;
  }
};



export const fetchcesbarchart = async (payload) => {

  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}cesSalesMonthChart`, payload
    );

    // console.log("Fleet ID API result:", payload);

    return res.data.result || []; // return array safely
  } catch (error) {
    console.error("Error fetching fleet ID:", error);
    throw error;
  }
};



export const fetchdssatbarchart = async (payload) => {

  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}dssatSalesMonthChart`, payload
    );

    // console.log("Fleet ID API result:", payload);

    return res.data.result || []; // return array safely
  } catch (error) {
    console.error("Error fetching fleet ID:", error);
    throw error;
  }
};



export const fetchcesbarchart2 = async (payload) => {

  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}cesServiceMonthChart`, payload
    );

    // console.log("Fleet ID API result:", payload);

    return res.data.result || []; // return array safely
  } catch (error) {
    console.error("Error fetching fleet ID:", error);
    throw error;
  }
};

export const fetchpsfchart2 = async (payload) => {

  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}psfServiceMonthChart`, payload
    );

    // console.log("Fleet ID API result:", payload);

    return res.data.result || []; // return array safely
  } catch (error) {
    console.error("Error fetching fleet ID:", error);
    throw error;
  }
};


export const fetchdssat2 = async (payload) => {

  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}dssatServiceMonthChart`, payload
    );

    // console.log("Fleet ID API result:", payload);

    return res.data.result || []; // return array safely
  } catch (error) {
    console.error("Error fetching fleet ID:", error);
    throw error;
  }
};
